/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { intlShape, injectIntl } from 'react-intl';
import { createUseStyles } from 'react-jss';

import styles from 'src/shared/app/authentication/component/base/AuthenticationBase.style';
import ForgotPasswordForm from './ForgotPasswordForm';
import ForgotPasswordSuccess from './ForgotPasswordSuccess';
import messages from 'src/shared/app/authentication/l10n/forgotPasswordL10n';
import ZIndexTopBar from 'src/shared/app/base/component/template/component/TopBar';
import TopBar, {
  backButton,
} from 'src/shared/app/nav/component/top-bar/TopBar';

type Props = {
  isLinkSent: boolean,
  handleHelpClick: () => void,
  handleBack: () => void,
  // Self passed
  // $FlowIssue
  intl: intlShape,
};

const useStyles = createUseStyles(styles);

const ForgotPasswordSectionDumb = ({
  isLinkSent,
  handleHelpClick,
  handleBack,
  intl,
}: Props): React.Node => {
  const classes: Object = useStyles();

  const elt = isLinkSent ? (
    <ForgotPasswordSuccess />
  ) : (
    <ForgotPasswordForm handleHelpClick={handleHelpClick} />
  );

  return (
    <section className={classes.section}>
      <ZIndexTopBar>
        <TopBar
          title={intl.formatMessage(messages.heading)}
          handleCancel={handleBack}
          variant={backButton}
        />
      </ZIndexTopBar>
      {elt}
    </section>
  );
};

export default compose(injectIntl)(ForgotPasswordSectionDumb);
